import { createStore } from 'satcheljs';
import { IScriptPageState } from './schema/IScriptPageState';

export const getScriptPageStore = createStore<IScriptPageState>('ScriptPageState', {
  script: '',
  copyScriptIcon: 'Copy',
  copyCodeIcon: 'Copy',
});
